import React from "react";
import { Container, Row, Col } from "shards-react";
import Bookings from "../components/common/bookings/Bookings";

const BookingsView = props => {
  return <Bookings />;
};

export default BookingsView;
